module.exports = __webpack_public_path__ + "img/paperwork.823c620.jpg";